export interface GeoLocation {
  lat: number;
  lng: number;
}

export interface PickupItem {
  id: string;
  units: number;
  yards: number | null;
  weight: number;
  ratingClass: string;
  description: string | null;
  notes: string;
  sidemark: string;
  packageType: string;
  length: string;
  width: string;
  height: string;
  diameter: string;
  commodityCode: string | null;
  commodityCodeDescription: string | null;
  pickedUpStatus: boolean;
}

export interface Pickup {
  pickupId: string;
  pickupNumber: string;
  pickupDate: string;
  pickupReadyTime: string;
  pickupCloseTime: string;
  pickupStatus: string;

  driverId: string | null;
  driverName: string | null;

  groupId: string;
  completedTime: string | null;

  probillNumber: string | null;
  bolNumber: string | null;

  specialInstructions: string;

  shipperAccountNumber: string;
  shipperName: string;
  shipperAddress1: string;
  shipperCity: string;
  shipperState: string;
  shipperPostalCode: string;
  shipperGeolocation: GeoLocation;

  consigneeName: string | null;
  consigneeAddress1: string;
  consigneeCity: string;
  consigneeState: string;
  consigneePostalCode: string;
  /** Present when API returns contact fields for assignment UI */
  shipperMobilePhone?: string;
  shipperEmail?: string;
  consigneePhone?: string;
  consigneeEmail?: string;

  itemCount: number;
  totalUnits: number;
  totalWeight: number;

  commodityCode: string | null;
  itemsList: PickupItem[];

  requesterTeamId: string;
  requesterTeamName: string;

  documents: any[];

  originTerminalCode: number;
  destinationTerminalCode: number;

  originServiceCenter: string | null;
  destinationServiceCenter: string | null;

  billingApprovedDate: string | null;
  billingApprovedUser: string | null;
}

export interface StaticRouteGroup {
  staticRouteNumber: string;
  staticRouteName: string;
  staticRouteDays: string;
  staticRouteGroup: string;
  pickups: Pickup[];
}

/** Totals for All / At Risk / Late tabs from grouped-by-static-route API. */
export interface UnassignedTabCounts {
  all: number;
  atRisk: number;
  late: number;
}

export interface UnassignedPickupState {
  staticRouteGroups: StaticRouteGroup[];
  pickupsWithoutStaticRoute: Pickup[];
  /** Set when API includes counts (any filter response may send full tab totals). */
  unassignedTabCounts?: UnassignedTabCounts;
  /** Terminal the grouped unassigned payload was loaded for (Pickup Assignment V2). */
  loadedForTerminalId?: number;
}

export const initialState: UnassignedPickupState = {
  staticRouteGroups: [],
  pickupsWithoutStaticRoute: [],
};
